<p-dialog
    [(visible)]="visible"
    [style]="{ width: '50vw', 'height': '80vh' }"
    [breakpoints]="{ '992px': '75vw', '576px': '90vw' }"
    [closeOnEscape]="true"
    [closable]="true"
    [dismissableMask]="true"
    [draggable]="false"
    [modal]="true"
    [header]="'inputs.search' | translate"
    (onShow)="focusOnInput()"
>
    <div class="flex-column flex-1 gap">
        <app-search-input #search [form]="form" [showLabel]="false"></app-search-input>

        @if (form.value.search?.length) {
            <p-tabs [(value)]="activeIndex" [scrollable]="true">
                <p-tablist>
                    <p-tab [value]="0">{{ 'common.all' | translate }}</p-tab>
                    @for (tab of store.searchTabs; let i = $index; track $index) {
                        <p-tab [value]="i + 1">{{ (store.labelOverride[tab] || (tab + '.labelMulti')) | translate }}
                        </p-tab>
                    }
                    <p-tab [value]="store.searchTabs.length + 1">{{ 'entities.history.labelMulti' | translate }}</p-tab>
                </p-tablist>
            </p-tabs>

            <div class="flex-column flex-1 gap pr-2">
                <!-- All tab -->
                @let data = store.data.results$ | async;
                @if (activeIndex() === 0) {
                    @for (item of data; track $index) {
                        <app-search-result [item]="item" (clickChange)="hide()" [withTag]="true"></app-search-result>
                    }
                    @if (!data?.length && !store.loading) {
                        <ng-container *ngTemplateOutlet="emptyState"></ng-container>
                    }
                    @if (data?.length && store.hasAnyMore) {
                        <ng-container
                            [ngTemplateOutlet]="loadNextBtn"
                            [ngTemplateOutletContext]="{ $implicit: 'all' }"
                        ></ng-container>
                    }
                }

                <!-- Entity tabs -->
                @for (tab of store.searchTabs; let index = $index; track $index) {
                    @if (activeIndex() === (index + 1)) {
                        @let items = store.only$[tab] | async;
                        @for (item of items; track $index) {
                            <app-search-result [item]="item" (clickChange)="hide()"></app-search-result>
                        }
                        @if (!items?.length && !store.loading) {
                            <ng-container *ngTemplateOutlet="emptyState"></ng-container>
                        }
                        @if (data?.length && !store.isLast[tab]) {
                            <ng-container
                                [ngTemplateOutlet]="loadNextBtn"
                                [ngTemplateOutletContext]="{ $implicit: tab }"
                            ></ng-container>
                        }
                    }
                }

                <!-- History tab -->
                @if (activeIndex() === (store.searchTabs.length + 1)) {
                    @let history = store.onlyHistory$ | async;
                    @for (item of history; track $index) {
                        <app-search-result [item]="item" (clickChange)="hide()" [withTag]="true"></app-search-result>
                    }
                    @if (!history?.length && store.loading <= 0) {
                        <ng-container *ngTemplateOutlet="emptyState"></ng-container>
                    }
                    @if ((store.data.historyResults$ | async)?.length && !store.isHistoryLast) {
                        <ng-container
                            [ngTemplateOutlet]="loadNextBtn"
                            [ngTemplateOutletContext]="{ $implicit: 'history' }"
                        ></ng-container>
                    }

                }
            </div>

            @if (store.loading > 0) {
                <div class="w-full h-full flex justify-content-center align-items-center">
                    <app-loading></app-loading>
                </div>
            }
        } @else {
            <ng-container *ngTemplateOutlet="emptyState"></ng-container>
        }
    </div>
</p-dialog>

<ng-template #loadNextBtn let-entity>
    @if (!store.loading) {
        <app-link-button
            label="common.loadNext"
            (clickEvent)="loadNext(entity)"
            [disabled]="loadingNext"
            [loading]="loadingNext"
        ></app-link-button>
    }
</ng-template>

<ng-template #emptyState>
    <app-empty-state></app-empty-state>
</ng-template>
